import React from 'react';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import LoginScreen from '../../components/LoginScreen';


class Login extends React.Component {

  constructor() {
    super();
    this.state = {
      errorMsg: null,
      resetSuccess: false
    }
  }

  handleLogin = (email, pass, remember) => {
    //const _this = this
    let authState;
    if (remember) {
      authState = 'local'
    } else {
      authState = 'session'
    }
    this.props.firebase.auth().setPersistence(authState)
      .then(() => {
        this.props.firebase.login({ email: email, password: pass })
          .catch((error) =>
            this.setState({ errorMsg: error.message })
          )
      })
      .catch((error) =>
        this.setState({ errorMsg: error.message })
      )
  }


  handleResetPass = (email) => {
    this.props.firebase.resetPassword(email)
    this.setState({ resetSuccess: true })
  }

  render() {

    return (
    <LoginScreen
        changeLanguage={this.props.changeLanguage}
        login={this.handleLogin}
        resetPass={this.handleResetPass}
        errorMsg={this.state.errorMsg}
        resetSuccess={this.state.resetSuccess}
      />
    )
  }
}

const enhancer = compose(
  firebaseConnect()
)
export default enhancer(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx